export function spawnMovementDust(originPos, moveDir, options = {}) {
    if (!originPos || !moveDir || moveDir.len() <= 0) return;

    const backDir = moveDir.unit().scale(-1);
    const sideDir = vec2(-backDir.y, backDir.x);
    const jitter = (Math.random() - 0.5) * (options.jitter ?? 8);
    const footOffset = options.footOffset || vec2(0, 0);
    const footPos = originPos
        .add(footOffset)
        .add(backDir.scale(options.backOffset ?? 5))
        .add(sideDir.scale(jitter));
    const baseSize = options.size ?? 2;
    const baseOpacity = options.opacity ?? 0.34;
    const lifetime = (options.lifetime ?? 0.3) + Math.random() * (options.lifetimeVariance ?? 0.12);

    const dust = add([
        circle(baseSize + Math.random() * (options.sizeVariance ?? 1.4)),
        pos(footPos),
        anchor("center"),
        scale(1),
        color(...(options.color || [96, 88, 78])),
        opacity(baseOpacity),
        z(options.z ?? 90),
        "movement_dust",
        {
            age: 0,
            lifetime,
            velocity: backDir
                .scale((options.speed ?? 8) + Math.random() * (options.speedVariance ?? 10))
                .add(sideDir.scale(jitter * 0.6)),
        },
    ]);

    dust.onUpdate(() => {
        dust.age += dt();
        const t = Math.min(1, dust.age / dust.lifetime);
        dust.pos = dust.pos.add(dust.velocity.scale(dt()));
        dust.opacity = (1 - t) * baseOpacity;
        dust.scale = vec2(1 + t * 0.75);
        if (t >= 1) destroy(dust);
    });
}
